import { View } from 'es6/components/view'
import $ from 'init/jquery'
import { Defaults } from 'es-decorators'
import throttle from 'lodash/throttle'

/**
 * Вид для кнопки прокрутки страницы вверх (back to top)
 */

@Defaults({
  el: '.totop',

  events: {
    'click': 'toTop',
  },
  additionalOptions: ['mainWindow'],
})
export class ToTopView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.$window = this.mainWindow.$el
    let that = this
    // При прокрутке страницы:
    this.listenTo(this.mainWindow, 'window.scroll', throttle(() => {
      this.windowHeight = this.$window.height()
      that.showHideButton()
      that.stickToFooter()
    }, 100, { leading: true }))
  }
  /**
   * Прокрутка в верх экрана
   */
  toTop () {
    $('html,body').animate({ scrollTop: 0 }, 'slow')
  }
  /**
   * Прячет или показывает кнопку в зависимости от высоты окна
   */
  showHideButton () {
    // Показываем кнопку только после прокрутки полного экрана
    if (this.$window.scrollTop() <= this.windowHeight) {
      this.$el.fadeOut(1000)
    } else {
      this.$el.fadeIn(1000)
    }
  }
  /**
   * Прикрепляет кнопку к футеру, если доскроллили до него
   */
  stickToFooter () {
    const documentHeight = $(document).height(),
      windowHeight = this.windowHeight,
      limit = $('.js-totop-limit'),
      bottomLimit = limit.length ? limit.offset().top : 0
    let totopLimitHeight = documentHeight - bottomLimit
    // Чтобы кнопка не заходила на футер
    if ((documentHeight - this.$window.scrollTop()) <= (windowHeight + totopLimitHeight)) {
      this.$el.css({ position: 'absolute', bottom: totopLimitHeight + 'px' })
    } else {
      this.$el.css({ position: 'fixed', bottom: '0px' })
    }
  }
}
